// extracted by mini-css-extract-plugin
export default {"wrapper":"Helpful_wrapper__k3f+4","helpful_header":"Helpful_helpful_header__gTGHU","helpful_para":"Helpful_helpful_para__0PbEc"};